import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { updateProjectContact } from '@/features/projects/project-details/api/update-project-contact';
import { useToast } from '@/shared/hooks/use-toast';

export const useUpdateProjectContact = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('project', { keyPrefix: 'Shared' });

  return useMutation({
    mutationFn: updateProjectContact,
    onSuccess: () => {
      queryClient.invalidateQueries();
      toast({ title: t('project_contact_saved') });
    },
    onError: () => {
      toast({
        title: t('project_contact_error'),
        variant: 'destructive',
      });
    },
  });
};
